'use es6';

export default (({
  domain,
  accountName,
  companyName
}) => {
  if (accountName) {
    return accountName;
  }

  if (companyName && companyName.indexOf('<') !== -1) {
    return companyName;
  }

  return domain;
});